"use client";

import Link from "next/link";
import { useTranslation } from "react-i18next";
import ImageWithSkeleton from "@/common/ImageWithSkeleton";

const SOCIAL_LINKS = [
  {
    image: "/icons/icon-instagram.svg",
    link: "https://www.instagram.com/zipshowkorea/",
  },
  {
    image: "/icons/icon-youtube.svg",
    link: "https://www.youtube.com/channel/UC3zJz6XURcSkkqMBMpEUiKA",
  },
  {
    image: "/icons/icon-blog.svg",
    link: "https://blog.naver.com/zipshowkorea",
  },
];

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="w-full h-fit px-10 pt-10 pb-20 border-t border-gray-100 bg-gray-50 text-sm md:text-base">
      <div className="max-w-7xl mx-auto flex flex-col items-center md:justify-between md:flex-row gap-12 md:gap-0">
        {/* 왼쪽: 회사 정보 */}
        <div className="space-y-6">
          <div className="space-y-3">
            <p className="font-bold text-sm">{t("FOOTER_COMPANY_NAME")}</p>

            <div className="text-gray-600 text-xs space-y-1">
              <p>{t("FOOTER_INFO_1")}</p>
              <p>{t("FOOTER_INFO_2")}</p>
              <p>{t("FOOTER_INFO_3")}</p>
              <p>{t("FOOTER_INFO_4")}</p>
            </div>
          </div>

          <div className="text-gray-500 text-xs">{t("FOOTER_COPYRIGHT")}</div>
        </div>

        {/* 오른쪽: SNS + 다운로드 */}
        <div className="space-y-4 md:text-right">
          <div className="flex gap-4 md:justify-end">
            {SOCIAL_LINKS.map((item) => (
              <button
                key={item.image}
                onClick={() => window.open(item.link, "_blank")}
                className="relative size-8 aspect-square rounded-sm"
              >
                <ImageWithSkeleton
                  src={item.image}
                  alt={item.image}
                  fill
                  sizes="32px"
                />
              </button>
            ))}
          </div>

          <Link
            href="https://drive.google.com/drive/folders/1-ZVHZYjJyPoMF7LJd-_teg-BYFyvp9zB"
            rel="noopener noreferrer"
            target="_blank"
            className="block text-sm text-center border-2 border-blue-500/75 hover:bg-blue-100 text-blue-500! p-2 rounded-lg font-semibold transition"
          >
            {t("FOOTER_DOWNLOAD_COMPANY_PROFILE")}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
